/**
 * @generated SignedSource<<946bfee09c64f3e6ddd3c9cbab07a461>>
 * @relayHash ea273678a5c985c0053babf0f185662a
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 0b497951b118068d82bb77e253f1fcb758c4dde1aa7f8eb01bf559f5961522f2

import type { ConcreteRequest, Query } from 'relay-runtime';
export type JiraDeploymentsFeaturePrecondition = "ALL_SATISFIED" | "DEPLOYMENTS_EMPTY_STATE" | "NOT_AVAILABLE" | "%future added value";
export type uiDeploymentsFeaturePreconditionQuery$variables = {
  cloudId: string;
  projectKey: string;
};
export type uiDeploymentsFeaturePreconditionQuery$data = {
  readonly jira: {
    readonly deploymentsFeaturePreconditionByProjectKey: JiraDeploymentsFeaturePrecondition;
  };
};
export type uiDeploymentsFeaturePreconditionQuery = {
  response: uiDeploymentsFeaturePreconditionQuery$data;
  variables: uiDeploymentsFeaturePreconditionQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "projectKey"
  }
],
v1 = {
  "args": [
    {
      "kind": "Variable",
      "name": "cloudId",
      "variableName": "cloudId"
    },
    {
      "kind": "Variable",
      "name": "projectKey",
      "variableName": "projectKey"
    }
  ],
  "kind": "ScalarField",
  "name": "deploymentsFeaturePreconditionByProjectKey"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "uiDeploymentsFeaturePreconditionQuery",
    "selections": [
      {
        "kind": "RequiredField",
        "field": {
          "concreteType": "JiraQuery",
          "kind": "LinkedField",
          "name": "jira",
          "plural": false,
          "selections": [
            {
              "kind": "RequiredField",
              "field": (v1/*: any*/),
              "action": "THROW",
              "path": "jira.deploymentsFeaturePreconditionByProjectKey"
            }
          ]
        },
        "action": "THROW",
        "path": "jira"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "uiDeploymentsFeaturePreconditionQuery",
    "selections": [
      {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          (v1/*: any*/)
        ]
      }
    ]
  },
  "params": {
    "id": "0b497951b118068d82bb77e253f1fcb758c4dde1aa7f8eb01bf559f5961522f2",
    "metadata": {},
    "name": "uiDeploymentsFeaturePreconditionQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "3337e3d6b76da02b643c63aacd15b239";

export default node;
